import React from 'react';
import { connect } from 'react-redux';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';

import {
    Modal,
    Button
} from 'react-bootstrap';

import './ControlStation.css';

import * as actions from '../../../store/actions';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Switch from '../../../components/UI/Switch/Switch';

class ControlStation extends React.PureComponent {
    
    state = {
        isOwner: "owner",
        show: false,
        controllerIds: []
    }

    handleClose = () => {
        this.setState({
            show: false,
            controllerIds: [
                ...this.props.controllerIds
            ]
        })
    }

    refreshHandler = () => {
        this.props.fetchDeviceConfigs(1, this.props.ownerId, this.state.isOwner, this.props.token);
    }

    openChooseControlStation = () => {
        this.setState({
            show: true
        })
    }

    componentDidMount() {
        this.setState({
            isOwner: this.props.isOwner
        })
        if(!this.props.finish && this.props.token) {
            this.props.fetchDeviceConfigs(1, this.props.ownerId, this.props.isOwner, this.props.token);
        }
        if(
            !this.props.loading 
            && this.props.finish
        ) {
            this.setState({
                controllerIds: [
                    ...this.props.controllerIds
                ]
            }, () => {
                this.props.addControllerStationIds([
                    ...this.state.controllerIds
                ]);
                this.props.save(this.state.controllerIds, this.props.controllerNames)
            })
        }
    }

    componentDidUpdate() {
        if(!this.props.loading && !this.props.finish && this.props.token) {
            this.props.fetchDeviceConfigs(1, this.props.ownerId, this.state.isOwner, this.props.token);
        }
    }

    handleSave = () => {
        this.setState({
            show: false
        }, () => {
            this.props.addControllerStationIds([
                ...this.state.controllerIds
            ]);
            this.props.save(this.state.controllerIds, this.props.controllerNames)
        })
    }

    render() {
        const options = {
            page: 1,
            sizePerPageList: [ 
                {
                    text: '15', value: 15
                }, 
                {
                    text: '25', value: 25
                }, 
                {
                    text: '50', value: 50
                } 
            ],
            sizePerPage: 15,
            pageStartIndex: 1,
            paginationSize: 3,
            prePage: 'Prev',
            nextPage: 'Next',
            firstPage: 'First',
            lastPage: 'Last',
            paginationPosition: 'bottom'
        };

        function planNameFormatter(cell, row) {
            return (
                `<p>${cell}</p>`
            );
        }

        let content = <Spinner></Spinner>
        let controllerIds = [];
        if(!this.props.loading && this.props.finish) {
            const controllerStations = [...this.props.controllerStations];
            if(
                !this.props.initControllerIds 
                && this.state.controllerIds.length <= 0
            ) {
                const controllerStationsLength = controllerStations.length;
                for(let i = 0; i < controllerStationsLength; i++) {
                    if(!this.state.controllerIds.includes(controllerStations[i].controller) &&
                        !controllerIds.includes(controllerStations[i].controller)
                    ) {
                        controllerIds.push(controllerStations[i].controller)
                    }
                }
                if(controllerIds.length > 0) {
                    this.setState({
                        controllerIds: [
                            ...controllerIds
                        ]
                    }, () => {
                        this.props.addControllerStationIds([
                            ...this.state.controllerIds
                        ]);
                    })
                }
            }
            
            const selectRowProp = {
                mode: 'checkbox',
                clickToSelect: true,
                selected: [
                    ...this.state.controllerIds
                ],
                onSelect: (row, isSelected, e) => {
                    const controller = row.controller;
                    let controllerIds = [...this.state.controllerIds];
                    if(isSelected) {
                        if(!controllerIds.includes(controller)) {
                            controllerIds.push(controller);
                        }
                    }
                    else {
                        if(controllerIds.includes(controller)) {
                            controllerIds.splice(controllerIds.indexOf(controller),1);
                        }
                    }
                    this.setState({
                        controllerIds: [...controllerIds]
                    })
                },
                onSelectAll: (isSelected, rows) => {
                    let controllerIds = [];
                    if(isSelected) {
                        controllerIds = rows.map(value => {
                            return value.controller
                        }) 
                    }
                    this.setState({
                        controllerIds: [...controllerIds]
                    })
                }          
            };

            content = (
                <BootstrapTable data={ controllerStations } selectRow={ selectRowProp } options={options} pagination={ true }>
                    <TableHeaderColumn width='150' dataField='controller' isKey={true} dataSort={true} filter={ { type: 'TextFilter', delay: 1000 } }>Control Station Id</TableHeaderColumn>
                    <TableHeaderColumn width='150' dataField='name'  dataSort={true} filter={ { type: 'TextFilter', delay: 1000 } }>Name</TableHeaderColumn>
                    <TableHeaderColumn width='150' dataField='deviceModel'  dataSort={true} filter={ { type: 'TextFilter', delay: 1000 } }>Device Model</TableHeaderColumn>
                    <TableHeaderColumn width='150' dataField='plan' dataFormat={planNameFormatter} dataSort={true} filter={ { type: 'TextFilter', delay: 1000 } }>Plan</TableHeaderColumn>
                    <TableHeaderColumn width='150' dataField='planExpiryValue'  dataSort={true} filter={ { type: 'TextFilter', delay: 1000 } }>Plan Expiry</TableHeaderColumn>
                    <TableHeaderColumn width='150' dataField='comment'  dataSort={true} filter={ { type: 'TextFilter', delay: 1000 } }>Comment</TableHeaderColumn>
                </BootstrapTable>
            );
        }

        return (
            <div className="ControlStation">
                <div className="box box-info">
                    <div className="box-header with-border">
                        <h3 className="box-title">{this.props.title}</h3>
                        <div className="pull-right box-tools">
                            <button type="button" className="btn btn-info btn-sm" onClick={this.openChooseControlStation}>
                                Select
                            </button>
                        </div>
                    </div>
                    <div className="box-body">
                        <div className="col-md-12 col-lg-12 col-xs-12 controller_name">
                            {
                                this.state.controllerIds.filter((value, key) => {
                                    if(key > 10) {
                                        return false;
                                    }
                                    return true;
                                }).map((value, key) => {
                                    if(key === 10) {
                                        return <a key={key} onClick={this.openChooseControlStation} style={{
                                            cursor:"pointer"
                                        }}>[more...]</a>
                                    }
                                    const name = this.props.controllerNames[value];
                                    return (
                                        <a key={key} className="btn btn-success btn-xs controllerTag">{name}</a>
                                    )
                                })
                            }                           
                        </div>
                    </div>
                    {
                        this.props.isCombineController ? (
                            <div className="box-footer">
                                <Switch
                                    value={this.state.isOwner === "owner" ? true : false}
                                    onlabel="OWNER" offlabel="OTHER" 
                                    isSmall={"btn-sm"}
                                    onChange={(checked) => {
                                        this.setState({
                                            isOwner: checked ? "owner": "notOwner"
                                        }, () => {
                                            this.refreshHandler()
                                        })
                                    }}
                                ></Switch>
                            </div>
                        ) : null
                    }
                </div>
                <Modal size="full" show={this.state.show} onHide={this.handleClose} aria-labelledby="example-modal-sizes-title-lg">
                    <Modal.Header>
                        <Modal.Title>Select Control Station</Modal.Title>
                    </Modal.Header>
                        <Modal.Body>{content}</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="secondary" onClick={this.refreshHandler}>
                            Refresh
                        </Button>
                        <Button variant="primary" onClick={this.handleSave}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        controllerStations: state.outlet.controllerStations,
        controllerIds: state.outlet.controllerIds,
        controllerNames: state.outlet.controllerNames,
        initControllerIds: state.outlet.initControllerIds,
        loading: state.outlet.loading,
        finish: state.outlet.finish,
        stateIsOwner: state.outlet.isOwner
    };
};


const mapDispatchToProps = dispatch => {
    return {
        fetchDeviceConfigs: (page, ownerId, isOwner, token) => {
            return dispatch( actions.fetchDeviceConfigs(page, ownerId, isOwner, token) );
        },
        addControllerStationIds: (ids) => {
            return dispatch( actions.addControllerStationIds(ids) );
        }
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ControlStation );